import { gql } from '@apollo/client';

export const postPUSF = gql`
mutation PUSFApiRQ{
    PUSFApiRS(input: $input)  
        @rest(type: "PUSFApiRS", path: "/gateway/formularios/pusf/form", method: "POST"){
            resultado
            mensaje
            nroSecuencia
            nroSolicitud
            errors
            message
            claimNumber
        }
}
`